import { defineComponent as _defineComponent } from 'vue'
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppToolbar from '@/components/layout/AppToolbar.vue'
import AppBottomNav from '@/components/layout/AppBottomNav.vue'
import AppAlert from '@/components/layout/AppAlert.vue'
import AppUpdateMessage from '@/components/layout/AppUpdateMessage.vue'
// import AppNotificationBanner from '@/components/layout/AppNotificationBanner.vue'
import { authModule } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return { __sfc: true,AppSidebar, AppToolbar, AppBottomNav, AppAlert, AppUpdateMessage, authModule }
}

})